<template>
  <div class="about">
    <h2 v-if="props.showTitle">关于我们</h2>
    <div v-if="props.showTitle" class="describe">创新驱动变革，专业铸就卓越</div>
    <div class="main flex-between">
      <img :src="product">
      <div class="detail">
        <div class="title" v-if="!props.showTitle">关于我们<span class="mini-font">About us</span></div>
        <p class="info">
          中山市横栏镇务实软件销售部成立于2011年， 现位于粤港澳大湾区腹地——中山市横栏镇，是一家 专业研发、销售 工厂、企业 流程类管理软件 的软件公司！本公司 以 “实用化、个性化、差异化” 为基本出发点， 全心全意 为中小企业 提供 “务实、极简”的 各类解决方案！软件突破 “人管人”的管理瓶颈，逐步协助企业建立流程、规则、体系，让工厂管理逐步迈入流程化、自动化的快速发展轨道！部分软件支持手机、电脑、平板、触屏，支持门市、工厂数据互联互通！一套软件在手，各种数据尽有！拥有了务实软件，工厂未来的发展定会阔步向前！
        </p>
        <p class="info">
          务实软件经过多年发展，已形成了从开单、跟单软件、到仓管软件、财务软件、到 计划软件、成本管理、ERP系统等 比较完备的 软件产品线，也可根据企业实际情况，量身定制！务实软件能轻松解决处于不同发展阶段企业的难题！选择了务实软件，公司、企业的发展，必定会加速向前！——愿务实.流程管理软件 成为贵企业永远立于不败之地的竞争利器！
        </p>
        <p class="info">
          务实软件拥有一批多年扎根企业的实干型研发团队，从经销、代工到自主品牌，我们在沉淀精华的同时，努力汲取新的养份，不断迭代出更适合企业发展需要的好产品！ 我们在改进、完善的路上 一往无前！
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  showTitle: {
    type: Boolean,
    default: false
  }
});
import product from "@/assets/images/aboutUs.jpg";

</script>

<style scoped lang="scss">
.about {
  padding: 20px 0;
  background: $bg-color;
  h2 {
    text-align: center;
    font-size: 36px;
    color: #000;
  }
  .describe {
    text-align: center;
    margin: 12px 0 30px;
    color: #666;
  }
  .flex-between {
    gap: 70px;
    img {
      width: 600px;
      // height: 320px;
    }
    .detail {
      flex: 1;
      .title {
        padding: 0 0 20px;
        font-size: 24px;
        color: #666;
      }
      .info {
        font-size: 16px;
        line-height: 24px;
        color: #999;
        text-indent: 2em;
      }
    }
  }
}
</style>
